<template>
  <dispatch-renderer
    v-if="dataLength > index"
    :schema="control.schema"
    :uischema="childUiSchema"
    :path="composePaths(control.path, `${index}`)"
    :enabled="control.enabled"
    :renderers="control.renderers"
    :cells="control.cells"
  >
  </dispatch-renderer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  DispatchRenderer,
  rendererProps,
  useJsonFormsArrayControl,
} from '@jsonforms/vue2';
import {
  and,
  ControlElement,
  hasType,
  JsonFormsRendererRegistryEntry,
  rankWith,
  schemaMatches,
  uiTypeIs,
} from '@jsonforms/core';
import { useElementArrayControl } from '../util';

const arrayItemProviderRenderer = defineComponent({
  name: 'array-item-renderer',
  components: {
    DispatchRenderer,
  },
  props: {
    ...rendererProps<ControlElement>(),
  },
  setup(props) {
    const control = useElementArrayControl(useJsonFormsArrayControl(props));

    return {
      ...control,
    };
  },
  computed: {
    index() {
      return typeof this.control.uischema.options?.index === 'number'
        ? this.control.uischema.options?.index
        : -1;
    },
    dataLength() {
      return this.control.data?.length || 0;
    },
  },
});

const isArray = schemaMatches((schema, _rootSchema) =>
  hasType(schema, 'array')
);

export default arrayItemProviderRenderer;

export const entry: JsonFormsRendererRegistryEntry = {
  renderer: arrayItemProviderRenderer,
  tester: rankWith(20, and(isArray, uiTypeIs('ArrayItem'))),
};
</script>
